import React, { FC } from "react";
import { ICalculationParametersData } from "types";
import {
  formatDate,
  formatPercent,
  transformCalculationParametersData,
} from "utils/format";
import cns from "classnames";
import styles from "../MobilePayouts/MobilePayouts.module.scss";

interface MobileCalculationParametersProps {
  data: ICalculationParametersData[];
  classname: string;
}

export const MobileCalculationParameters: FC<
  MobileCalculationParametersProps
> = ({ data, classname }) => {
  const transformedData = transformCalculationParametersData(data);

  if (data.length === 0) {
    return <div className={styles.noData}>Нет данных</div>;
  }

  return (
    <div className={cns(classname)}>
      {transformedData.map(
        (item: ICalculationParametersData, index: number) => (
          <div className={styles.item} key={index}>
            <div className={styles.row}>
              <div className={styles.rowTitle}>Начало периода:</div>
              <div className={styles.rowValue}>
                {formatDate(item["beginningOfPeriod"])}
              </div>
            </div>

            <div className={styles.row}>
              <div className={styles.rowTitle}>Конец периода:</div>
              <div className={styles.rowValue}>
                {formatDate(item["endOfPeriod"])}
              </div>
            </div>
            <div className={styles.row}>
              <div className={styles.rowTitle}>Тип расчета:</div>
              <div className={styles.rowValue}>{item.calculationType}</div>
            </div>
            <div className={styles.row}>
              <div className={styles.rowTitle}>Основной %:</div>
              <div className={styles.rowValue}>
                {formatPercent(item.basicInterestRate)}
              </div>
            </div>
            <div className={styles.row}>
              <div className={styles.rowTitle}>Минимальный %:</div>
              <div className={styles.rowValue}>
                {formatPercent(item.minimumInterestRate)}
              </div>
            </div>
          </div>
        )
      )}
    </div>
  );
};
